import { Helmet } from 'react-helmet';
import {
    Box,
    Button,
    Card,
    CardHeader,
    CardActions,
    CardContent,
    Chip,
    Container,
    Divider,
    Link,
    Grid,
    Typography,
    Paper,
    TextField,
    Switch,
    FormGroup,
    FormControlLabel,
    MenuItem,
    Select,
    FormHelperText
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import emtyData from "../../../../assets/images/emty-data.png";
import { Formik } from "formik";
import * as Yup from 'yup';
import DialogIcon from "../../../../components/kpi/DialogIcon";
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../../../services/global.service";
import Icon from '@mui/material/Icon';
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import adminService from "../../../../services/admin.service";

const styles = {
    path: {
        color: "#68717A",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    buttonFile: {
        position: "absolute",
        right: "1px",
        top: "1px",
        // bottom: "9px",
        background: "linear-gradient(0deg, #E5E9EC, #E5E9EC), #404349",
        borderLeft: "1px solid #CED4DA",
        "border-radius": "0px 4px 4px 0px",
        width: "100px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
    dropdowm: {
        position: "absolute",
        right: "20px",
        top: "40%",
        // bottom: "9px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
};

const GoalGroupCreate = (props) => {
    const { t } = useTranslation();
    let { serial, groupID } = useParams()

    const useStyles = makeStyles({
        iconContainer: {
            '& svg': {
                width: "45px",
                height: "45px"
            }
        },
        formTextField: {
            '& .MuiTextField-root': { m: 1, width: '25ch' },
        },
        input: {
            '& div > input': {
                height: '8px',
                position: "relative"
            }
        },

        inputError: {
            '& div > input': {
                color: "#CC6058",
                background: "#CC60581A",
                textAlign: "center",
                height: '6px',
                border: "1px solid #CC6058 !important",
                borderRadius: "4px"
            }
        },
        disabled: {
            '& div > input': {
                height: '8px',
                position: "relative"
            },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            }
        },

    })
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const classes = useStyles();
    const [status, setStatus] = React.useState(true);
    const [edit, setEdit] = React.useState(false);
    const [openIcon, setOpenIcon] = React.useState(false);
    const [backgroundColorValue, setBackgroundColorValue] = React.useState("#5DA196");
    const [allow_adjust, setAllowAdjust] = React.useState(false);
    const [backgroundColorStatus, setBackgroundColorStatus] = React.useState(false);
    const [errorText, seterrorText] = React.useState("");
    const [title, setTitle] = React.useState("");
    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const [isUsed, setIsUsed] = React.useState(false);
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const handleStatus = () => {
        setStatus(!status)
    }
    const [formData, setFormData] = React.useState({
        code: '',
        nameEN: '',
        nameTH: '',
    });

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: "50px !important",
        height: "24px !important",
        padding: "0 !important",
        marginRight: "10px",
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: "4px 6px",
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(22px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#5DA196',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 1,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 1,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 16,
            height: 16,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#C0C0C0' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
        "& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track": {
            backgroundColor: "#D8D8D8!important"
        }
    }));
    const validationSchema = yup.object({
        code: yup.string().required(t('admin.inputForm.msgError.code')),
        nameEN: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),
        // nameTH: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),

    });
    const formik = useFormik({
        initialValues: {
            code: "",
            nameEN: "",
            nameTH: "",
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            submit(values)
            // openSuccessAddDialog(true)
        },
    });

    const handleSubmit = () => {
        formik.submitForm()
    }
    const handleCancel = () => {
        setDiscardDialog(true)
    }

    const [discardDialog, setDiscardDialog] = React.useState(false);
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        handleDiscardDialog(false)
        navigate('/admin/goal-group/' + groupID, { replace: false });
    };
    const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
    const handleDirect = () => {
        openSuccessAddDialog(false)
        navigate('/admin/goal-group/' + groupID, { replace: false });
    }
    const submit = (data) => {
        adminService.editGoalGroup({
            code: data.code,
            name_en: data.nameEN,
            name_th: data.nameTH,
            options: {
                goal_library_id: groupID
            },
            status: status === true ? "active" : "inactive",
        }, serial).then(
            (response) => {
                openSuccessAddDialog(true)
            },
        ).catch(() => {
            handleOpenFailedMessageDialog()
        })
    }

    useEffect(() => {
        adminService.detailGoalGroup(serial).then((rs) => {
            let data = rs?.data?.goal_library
            let dataDetail = rs?.data?.goal_group
            formik.setFieldValue("nameEN", dataDetail?.options?.name_en !== undefined ? dataDetail?.options?.name_en : dataDetail?.name)
            formik.setFieldValue("nameTH", dataDetail?.options?.name_th !== undefined ? dataDetail?.options?.name_th : "")
            formik.setFieldValue("code", dataDetail?.code)
            setStatus(dataDetail.status === "active" ? true : false)
            setAllowAdjust(data?.allow_adjust)
            setTitle(data?.name)
            setEdit(false)
            setIsUsed(dataDetail?.is_used ?? false)
        })
            .catch((err) => {

            })
    }, []);
    useEffect(() => {
        if (edit === false) {
            setEdit(true)
        }
    }, [formik.values, status]);
    return (
        <>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/admin/goal-library-master')}>{t('admin.label.goalLibraryMaster')}</span> / <span style={styles.link} onClick={() => clickLink('/admin/goal-group/' + groupID)}>{title}</span> / <span style={styles.end} >{serial !== undefined ? t('admin.label.editGoalGroup') : t('admin.label.createGoalGroup')}</span></Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} >
                            <Typography variant="h1" fontSize={36} lineHeight="53.82px" fontWeight="500" color="#404349">
                                {serial !== undefined ? t('admin.label.editGoalGroup') : t('admin.label.createGoalGroup')}
                            </Typography>
                        </Grid>
                        <Grid direction="column" sx={{}}
                            container item
                            justifyContent="center"
                            alignItems="center">

                            <Grid container item>
                                <Paper elevation={6} sx={{ 'border-radius': '20px', width: '100%' }} classes={{ root: classes.error }}>

                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "50px 0px 20px 25px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.code')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.code && formik.errors.code)}
                                                fullWidth
                                                helperText={formik.touched.code && formik.errors.code}
                                                margin="normal"
                                                name="code"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.code}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.code')}
                                                classes={{ root: serial !== undefined ? classes.disabled : allow_adjust === true ? classes.input : classes.disabled }}
                                                disabled={serial !== undefined ? true : allow_adjust === true ? false : true}
                                            />
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.status')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <Box sx={{ paddingTop: "16px", height: "100%", "max-height": "55px", display: "flex", "align-items": "center" }}>
                                                <FormGroup >
                                                    <FormControlLabel
                                                        sx={{ m: 0 }}
                                                        control={<IOSSwitch checked={status} disabled={edit === false ? allow_adjust === true ? false : true : isUsed === true ? true : false} onChange={() => handleStatus()} />}
                                                        label={status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')}
                                                    // disabled
                                                    />
                                                </FormGroup>
                                                {/* <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography> */}
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 20px 25px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.nameEN')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.nameEN && formik.errors.nameEN)}
                                                fullWidth
                                                helperText={formik.touched.nameEN && formik.errors.nameEN}
                                                margin="normal"
                                                name="nameEN"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.nameEN}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.nameEN')}
                                                classes={{ root: serial !== undefined ? allow_adjust === true ? classes.input : classes.disabled : allow_adjust === true ? classes.input : classes.disabled }}
                                                disabled={serial !== undefined ? allow_adjust === true ? false : true : allow_adjust === true ? false : true}
                                            />
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.nameTH')}</Typography>
                                            <TextField
                                                // error={Boolean(touched.nameTH && errors.nameTH)}
                                                fullWidth
                                                // helperText={touched.nameTH && errors.nameTH}
                                                margin="normal"
                                                name="nameTH"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.nameTH}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.nameTH')}
                                                classes={{ root: serial !== undefined ? allow_adjust === true ? classes.input : classes.disabled : allow_adjust === true ? classes.input : classes.disabled }}
                                                disabled={serial !== undefined ? allow_adjust === true ? false : true : allow_adjust === true ? false : true}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container mt={3} mb={3} pr={4} >
                                        <Grid item xs display="flex" flexDirection="row-reverse">
                                            <Box sx={{ width: "100px" }}>
                                                <Button disabled={allow_adjust === true ? edit === true ? false : true : true} onClick={handleSubmit} color="primary" variant="contained" fullWidth>
                                                    {t('label.save')}
                                                </Button>
                                            </Box>
                                            <Box mr={2} sx={{ width: "100px" }}>
                                                <Button color="black" variant="outlined" fullWidth onClick={handleCancel}>
                                                    {t('label.cancel')}
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>

                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <SimpleDialog
                        open={isSuccessAddDialogOpen}
                        doDirect={() => handleDirect()}
                        setValue={openSuccessAddDialog}
                        text={t('admin.label.GoalLibraryGroupEditSuccessfully')}
                        page={true}
                    />
                    <MessageDialog
                        open={openFailedMessageDialog}
                        setValue={handleCloseFailedMessageDialog}
                        type="fail"
                        title={t(`dialog.label.fail`)}
                        text={t(`admin.label.GoalLibraryGroupEditFail`)}
                    />
                    <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t('label.confirmationOfDiscard')} text={t('label.youSureDiscardChange')} />
                </Container>
            </Box>
        </>
    )
};
export default GoalGroupCreate;
